import {Injectable, OnDestroy} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {Store} from '@ngrx/store';

import * as environment from 'environments/environment';

import flatpickr from 'flatpickr';
import {Danish} from 'flatpickr/dist/l10n/da';
import {German} from 'flatpickr/dist/l10n/de';
import {english} from 'flatpickr/dist/l10n/default';
import {Spanish} from 'flatpickr/dist/l10n/es';
import {Finnish} from 'flatpickr/dist/l10n/fi';
import {French} from 'flatpickr/dist/l10n/fr';
import {Norwegian} from 'flatpickr/dist/l10n/no';
import {Polish} from 'flatpickr/dist/l10n/pl';
import {Slovenian} from 'flatpickr/dist/l10n/sl';
import {Swedish} from 'flatpickr/dist/l10n/sv';

import * as moment from 'moment';

import 'moment/locale/en-gb';
import 'moment/locale/sv';
import 'moment/locale/de';
import 'moment/locale/fi';
import 'moment/locale/fr';
import 'moment/locale/nb';
import 'moment/locale/da';
import 'moment/locale/es';
import 'moment/locale/pl';


import {startWith, Subject} from 'rxjs';
import {filter, takeUntil} from 'rxjs/operators';
import * as translationsAction from './app/translation.actions';
import 'moment/locale/sl';

@Injectable({
    providedIn: 'root'
})
export class TranslationsHelperService implements OnDestroy{

    private readonly _destroyed$ = new Subject<void>();

    constructor(private _translocoService: TranslocoService, private store: Store) {
        this._translocoService.events$
            .pipe(
                startWith({
                    type: 'translationLoadSuccess'
                }),
                filter(e => e.type === 'translationLoadSuccess' || e.type ==='langChanged'),
                takeUntil(this._destroyed$)
            ).subscribe(()=>this.store.dispatch(translationsAction.selectedTranslationChanged()));
    }

    ngOnDestroy(): void {
        this._destroyed$.next();
        this._destroyed$.complete();
    }

    changeLanguage(language: string) {
        const languageToSet = environment.environment.locale.availableLanguages.indexOf(language) > -1
            ? language
            : environment.environment.locale.defaultLanguage;

        this._translocoService.setActiveLang(languageToSet);
        this.setMomentJSLanguage(languageToSet);
        this.setFlatpickerLanguage(languageToSet)
        return languageToSet;
    }

    private setMomentJSLanguage(language: string) {
        switch (language) {
            case 'en':
                moment.locale('en-gb');
                break;
            case `no`:
                moment.locale('nb');
                break;
            default:
                moment.locale(language);
        }

    }

    private setFlatpickerLanguage(languageToSet: string) {
        const flatpackLangMapper = {
            'en':english ,
            'sv':Swedish ,
            'de': German ,
            'fi': Finnish,
            'fr':French ,
            'no': Norwegian,
            'da': Danish,
            'es': Spanish,
            'pl': Polish,
            'sl':Slovenian
        }

        flatpickr.localize(flatpackLangMapper[languageToSet] ?? english);

    }
}
